module.exports = __webpack_public_path__ + "img/pined.0b100105.png";